export default "__VITE_ASSET__CNVZ4$Nk__"